import React from 'react';
import { FormattedMessage } from 'react-intl';
import UserFormatter from '@afosto/utils-react/formatters/UserFormatter';
import { translation as translationFormatter } from '../DataGrid/formatters';

export const actorFormatter = (cell, row) => {
  const { entity_id: id, entity_type: type } = cell ?? {};

  if (!type) {
    return '-';
  }

  if (type === 'user') {
    return <UserFormatter userId={id} />;
  }

  return translationFormatter(type, row, {
    translationKey: 'auditActors.{value}',
  });
};

export const codeFormatter = (cell, row) => (
  <FormattedMessage
    id={`auditActions.${row.formattedCode}`}
    defaultMessage={cell}
    description="Audit action/code translation"
  />
);
